export const zhExtra = {
    // ── 会员权益 ──
    membership_feat_basic_analysis: '基础活动观察',
    membership_feat_daily_plant: '每日植物生成',
    membership_feat_ai_chat: 'AI 陪伴对话',
    membership_feat_advanced_analysis: '深度成长追踪',
    membership_feat_ai_memory: 'AI深度陪伴',
    membership_feat_daily_report: '个性化温室日记',
    membership_feat_weekly_report: '魔法笔一键输入',
    membership_feat_monthly_report: '待办分步完成',
    membership_feat_yearly_report: '深度成长追踪',
    membership_feat_mood_ai: 'AI心情判断',
    membership_feat_star_bottle_ai: 'AI追踪目标、习惯养成',
    // ── Timeline / DatePicker / EventCard (v1.2) ──
    date_picker_title: '选择日期',
    month_grid_title: '选择月份',
    mood_convert_btn: '转换',
    mood_return_event: '回归事件',
    mood_to_event: '转为事件',
    event_to_mood: '转为心情',
    image_upload: '上传图片',
    chat_input_error_need_text: '需要填写事件内容才可以记录哦',
    image_uploading: '上传中...',
    image_upload_fail: '上传失败，点击重试',
    image_delete: '删除图片',
    yesterday_popup: '昨天最后一件事',
    event_ongoing: '进行中...',
    end_event_btn: '结束',
    image_crop_title: '裁剪图片',
    image_crop_hint: '拖动调整位置',
    image_recrop: '重新裁剪',
    // ── 昨日回顾 (新的一天) ──
    yesterday_summary: '昨天你记录了 {{count}} 件事',
    previous_day_summary: '{{date}} 你记录了 {{count}} 件事',
    yesterday_last_activity: '最后在做：{{content}}',
    yesterday_tap_to_view: '点击查看该日记录',
    new_day_start: '新的一天，从一条记录开始',
    record_what_you_do: '记录你正在做的事情',
    // ── 晚间提醒 ──
    night_reminder_title: '今日还没完成哦',
    night_reminder_body: '植物和日记还没有生成，趁着晚上去记录一下今天吧～',
    night_reminder_go: '去生成',
    night_reminder_dismiss: '稍后再说',
    // ── 主动提醒系统 ──
    reminder_popup_confirm: '确认',
    reminder_popup_deny: '我在做别的',
    reminder_popup_or_tell_me: '或者直接告诉我',
    reminder_popup_input_placeholder: '写点什么...',
    reminder_activity_wake: '起床',
    reminder_activity_meal_breakfast: '吃早饭',
    reminder_activity_meal_lunch: '吃午饭',
    reminder_activity_meal_dinner: '吃晚饭',
    reminder_activity_work_start: '开始上班',
    reminder_activity_lunch_start: '午休吃饭',
    reminder_activity_lunch_end: '午休结束，继续工作',
    reminder_activity_work_end: '下班了',
    reminder_activity_sleep: '准备睡觉',
    reminder_activity_class_morning_start: '上午课开始',
    reminder_activity_class_morning_end: '上午课结束',
    reminder_activity_class_afternoon_start: '下午课开始',
    reminder_activity_class_afternoon_end: '下午课结束',
    reminder_activity_class_evening_start: '晚自习开始',
    reminder_activity_class_evening_end: '晚自习结束',
    reminder_hint_start: '现在在做{{activity}}吗？长按通知可一键开始计时。',
    reminder_hint_eat_start: '现在在吃{{activity}}吗？长按通知可一键开始计时。',
    reminder_hint_end: '现在准备结束{{activity}}了吗？长按通知可一键结束计时。',
    reminder_hint_noun_work: '工作',
    reminder_hint_noun_lunch: '午饭',
    reminder_hint_noun_dinner: '晚饭',
    reminder_hint_noun_study: '学习',
    reminder_hint_noun_rest: '休息',
    evening_check_event_count: '你今天记录了 {{count}} 件事',
    evening_check_grow_plant: '生成今日植物',
    evening_check_view_report: '查看今日日报',
    evening_check_snooze: '稍后提醒',
    // ── Onboarding 引导流程 ──
    quick_activity_picker_title: '现在在做什么？',
    quick_activity_meal: '吃饭',
    quick_activity_rest: '休息',
    quick_activity_entertainment: '娱乐',
    quick_activity_health: '运动',
    quick_activity_social: '社交',
    quick_activity_other: '其他',
    quick_activity_input_placeholder: '或者直接告诉我...',
    quick_activity_prefix_ended: '你结束{{activity}}了，',
    onboarding_step1_title: '认识一下',
    onboarding_step1_desc: 'Seeday 会在关键时间节点主动询问，帮你轻松记录每天的大小事。',
    onboarding_step1_cta: '开始设置',
    onboarding_step2_title: '开启提醒',
    onboarding_step2_desc: 'Seeday 会在上下班、用餐时间轻轻提醒你，帮你自动记录日常。',
    onboarding_step2_allow: '允许通知',
    onboarding_step2_skip: '稍后开启',
    onboarding_step3_title: '我的日程',
    onboarding_step3_desc: '告诉 Seeday 你有哪些固定日程，它会在合适的时间点提醒你记录。',
    onboarding_step4_title: '我的作息',
    onboarding_step4_desc: '填写你的大致作息时间，可随时在「我的」页面修改。',
    onboarding_step5_title: '一切就绪',
    onboarding_step5_desc: '你的提醒已配置好，每天关键时刻 Seeday 都会轻轻叫你一声。',
    onboarding_step5_cta: '开始使用',
    onboarding_save_error: '网络异常，请重试',
    onboarding_next: '下一步',
    onboarding_back: '上一步',
    onboarding_skip: '跳过',
    // ── 新版引导流 v2 ──
    onboarding2_language_title: '先选一种你更舒服的语言',
    onboarding2_language_desc: '后续引导与应用内容都会按这个语言呈现，可随时在设置中切换。',
    onboarding2_auth_title: 'Seeday，欢迎你回来',
    onboarding2_auth_desc: '把今天交给我，我们一起把生活记录得更有温度。',
    onboarding2_auth_placeholder: '邮箱',
    onboarding2_auth_password: '密码',
    onboarding2_auth_account_placeholder: '邮箱地址',
    onboarding2_auth_password_placeholder: '密码（至少 6 位）',
    onboarding2_auth_agreement: '继续即代表你已阅读并同意《服务协议》与《隐私政策》',
    onboarding2_auth_cta: '立即体验',
    onboarding2_auth_error: '邮箱或密码错误，请重试',
    onboarding2_routine_region: '所在地区',
    onboarding2_routine_region_placeholder: '例如：上海',
    onboarding2_routine_title: '让提醒更贴近你的节奏',
    onboarding2_routine_desc: '告诉 Seeday 你的节奏，它会在对的时机悄悄出现。',
    onboarding2_routine_identity_title: '你当前的生活状态',
    onboarding2_routine_basic_title: '基础作息',
    onboarding2_routine_saving: '正在保存...',
    onboarding2_routine_cta: '保存并继续',
    onboarding_trial_title: '欢迎来到 Seeday，7 天，送给你的完整体验。',
    onboarding_trial_subtitle: '新用户专属礼遇：7 天不限量体验，无需绑卡，到期自动暂停。',
    onboarding_trial_feat1_title: '每日个性化日记',
    onboarding_trial_feat1_desc: 'AI 每天根据你的活动和心情，自动生成专属日记，记录成长轨迹',
    onboarding_trial_feat2_title: '魔法笔',
    onboarding_trial_feat2_desc: '粘贴一段文字，AI 自动识别并整理成活动记录与待办',
    onboarding_trial_feat3_title: '待办拆解',
    onboarding_trial_feat3_desc: '大目标自动拆解成可执行的小步骤，推进更轻松',
    onboarding_trial_feat4_title: 'AI 心情识别',
    onboarding_trial_feat4_desc: '记录时 AI 实时读懂你的情绪，帮你看清内心规律',
    onboarding_trial_feat5_title: '目标追踪',
    onboarding_trial_feat5_desc: '设定目标，AI 每天从记录里找出相关进展，陪你见证习惯生长',
    onboarding_trial_feat6_title: '专属记忆',
    onboarding_trial_feat6_desc: '你随口提过的小事，AI 都用心替你记着，越用越懂你',
    onboarding_trial_feat7_title: '解锁全部温室伙伴',
    onboarding_trial_feat7_desc: 'Van、Agnes、Zep、Momo 全部开放，找到最懂你的灵魂伙伴',
    onboarding_trial_cta: '开始体验',
    onboarding_trial_footer: '试用结束后不会自动扣费，续费完全由你决定。随时可回到免费版。',
    onboarding2_ai_title: '选择您的 AI 伙伴',
    onboarding2_ai_van_badge: '初始解锁',
    onboarding2_ai_van_desc: '活泼的陪伴者，像清晨的喇叭花一样充满活力。',
    onboarding2_ai_agnes_badge: '高级订阅',
    onboarding2_ai_agnes_desc: '洞察深刻且优雅的陪伴者，擅长从琐碎日常中提炼哲思。',
    onboarding2_ai_cta: '就决定是你了',
    onboarding2_journal_title: '记录今天第一件事',
    onboarding2_journal_desc: '可以写一件正在发生的小事，也可以补一句此刻的心情。',
    onboarding2_journal_placeholder: '输入任何内容...',
    onboarding2_journal_mood_placeholder: '也可以补一句心情，比如：今天心里轻松了很多。',
    onboarding2_journal_sync_badge: '实时同步中',
    onboarding2_journal_syncing: '正在同步...',
    onboarding2_journal_footer: '每一次记录，都会长成明天的你',
    onboarding2_journal_cta: '发送至今日时间流',
    onboarding_j3_activity_title: '先记录一个活动',
    onboarding_j3_activity_hint: '例如：跑步、吃饭、开会',
    onboarding_j3_activity_placeholder: '输入活动，例如：跑步',
    onboarding_j3_shown_title: 'AI 已识别为活动',
    onboarding_j3_shown_desc: '认识一下卡片上的按钮',
    onboarding_j3_tip_camera: '也可以拍照记录，上传到活动卡',
    onboarding_j3_tip_convert: '识别错了？点这里把活动转成心情',
    onboarding_j3_tip_duration: '持续时长：{{duration}}',
    onboarding_j3_tip_duration_mode: '持续时长：{{duration}}（录入下一条活动会自动结算，也可点结束按钮手动结束）',
    onboarding_j3_tip_duration_prefix: '持续时长：{{duration}}（录入下一条活动时自动结算，或可点击',
    onboarding_j3_tip_duration_suffix: '手动结束）',
    onboarding_j3_tip_end_manual: '做完这件事时，可以点结束按钮手动结束计时',
    onboarding_j3_tip_end_auto: '如果你开始记录下一条活动，系统也会自动结束当前活动并记录时长',
    onboarding_j3_tip_end_both: '可手动点结束；也可直接开始下一条活动，系统会自动结束并记录时长',
    onboarding_j3_tip_camera_story: '为这件事拍张照片，留住此刻',
    onboarding_j3_tip_camera_crop: '可选择卡片展示区域；点击图片仍可查看完整原图',
    onboarding_j3_tip_convert_intent: '不想计时？点击切换为心情卡片，用来记录感受、灵感或想法。',
    onboarding_j3_tip_mood_tag: '这个心情标签用于记录做这件活动时的心情或状态，也可以自定义',
    onboarding_j3_tip_mood_mode: '心情模式不计时，适合记录你的心情、灵感或想法',
    onboarding_j3_tip_mood_linked: '这条心情会先关联在活动卡片下',
    onboarding_j3_tip_switch_back_event_continue: '你现在在测试中，请先点按钮切换回活动后再继续',
    onboarding_j3_tip_switch_back_mood_continue: '你现在在测试中，请先点按钮切换回心情后再继续',
    onboarding_j3_tip_mood_return: '把这条心情归回最近一条活动卡片',
    onboarding_j3_tip_mood_to_event: '把这条心情转成活动，并开始计时',
    onboarding_j3_tip_mood_detach_prefix: '点击心情旁边的',
    onboarding_j3_tip_mood_detach_suffix: '按钮，可将这条心情单独拆分成心情卡片',
    onboarding_j3_delete_blocked: '这条是引导示例记录，当前步骤不能删除',
    onboarding_j3_tip_cta: '了解了，继续',
    onboarding_j3_mood_title: '再记录一下心情',
    onboarding_j3_mood_hint: '例如：开心、疲惫、专注',
    onboarding_j3_mood_placeholder: '输入心情，例如：开心',
    onboarding_j3_mood_skip: '跳过',
    onboarding_j3_complete_title: '记录完成！',
    onboarding_j3_complete_desc: '还可以试试卡片上的各种操作',
    onboarding_j3_start_btn: '开始使用',
    onboarding_j3_magic_pen_teaser_title: '试试魔法笔一键输入吧！',
    onboarding_j3_magic_pen_teaser_desc: '输入一段文字，AI 自动整理成活动记录与待办',
    onboarding_j3_send: '发送',
    onboarding2_todo_title: '给今天立一个可完成的小目标',
    onboarding2_todo_add_placeholder: '添加待办事项...',
    onboarding2_todo_cta: '下一步',
    onboarding2_todo_hint: '先添加至少一条待办，再继续下一步',
    onboarding_timepicker_cancel: '取消',
    onboarding_timepicker_confirm: '确定',
    onboarding2_sub_title: '开启 Pro 体验',
    onboarding2_sub_feature_agnes: '解锁 Agnes AI 伙伴',
    onboarding2_sub_feature_records: '无限记录与日报分析',
    onboarding2_sub_feature_insights: '高级情绪洞察',
    onboarding2_sub_feature_support: '优先客服支持',
    onboarding2_sub_trial: '开启 7 天免费试用',
    onboarding2_sub_skip: '稍后购买，进入应用',
    onboarding2_sub_monthly_label: '月度订阅',
    onboarding2_sub_yearly_label: '年度订阅（最划算）',
    onboarding2_sub_monthly_price: '¥28/月',
    onboarding2_sub_yearly_price: '¥198/年',
    onboarding2_sub_tagline: '数据不再只是数字，让成长触手可及',
    onboarding2_sub_features_title: 'Pro 专属特权',
    onboarding2_sub_popular_badge: '首选推荐',
    onboarding2_sub_cta_trial: '立即开始 7 天免费试用',
    onboarding2_sub_cta_upgrade: '立即升级到 Pro',
    onboarding2_sub_skip_v2: '稍后购买，进入 App',
    onboarding2_sub_badge_cancel: '随时取消',
    onboarding2_sub_badge_secure: '安全支付',
    onboarding2_sub_plan_trial_name: '7天免费试用',
    onboarding2_sub_plan_trial_period_unit: '7天',
    onboarding2_sub_plan_trial_desc: '完全免费体验所有 Pro 功能',
    onboarding2_sub_plan_trial_tag: '推荐首选',
    onboarding2_sub_plan_yearly_name: '年度会员',
    onboarding2_sub_plan_yearly_period_unit: '年',
    onboarding2_sub_plan_yearly_desc: '限时优惠，平均 ¥8.33/月',
    onboarding2_sub_plan_yearly_tag: '省 15%',
    onboarding2_sub_feat_ai_label: '全部 AI 角色',
    onboarding2_sub_feat_ai_desc: '解锁所有性格的 AI 伙伴',
    onboarding2_sub_feat_growth_label: '深度成长分析',
    onboarding2_sub_feat_growth_desc: '全维度追踪心理与行为成长',
    onboarding2_sub_feat_memory_label: 'AI 专属记忆',
    onboarding2_sub_feat_memory_desc: '提供深度共鸣与持续反馈',
    // ── 日程与提醒（Profile 设置）──
    profile_schedule_section_title: '我的日程',
    profile_user_profile_has_work_schedule: '有固定的上班 / 工作时间',
    profile_user_profile_has_class_schedule: '有固定的上课时间',
    profile_user_profile_work_start: '上班开始',
    profile_user_profile_work_end: '上班结束',
    profile_user_profile_lunch_start: '午休开始',
    profile_user_profile_lunch_end: '午休结束',
    profile_schedule_dinner_time: '晚餐',
    profile_schedule_identity_free: '自由',
    profile_schedule_identity_work: '工作',
    profile_schedule_identity_class: '学生',
    profile_schedule_identity_current: '当前',
    profile_schedule_identity_switch_title: '确认切换身份',
    profile_schedule_identity_switch_body: '切换到「{{name}}」后，你的提醒安排将相应调整。',
    profile_schedule_work_fields: '工作时间',
    profile_schedule_class_fields: '课程时间',
    profile_user_profile_class_morning: '上午课',
    profile_user_profile_class_morning_start: '上午开始',
    profile_user_profile_class_morning_end: '上午结束',
    profile_user_profile_class_afternoon: '下午课',
    profile_user_profile_class_afternoon_start: '下午开始',
    profile_user_profile_class_afternoon_end: '下午结束',
    profile_user_profile_class_evening: '晚自习',
    profile_user_profile_class_evening_start: '晚间开始',
    profile_user_profile_class_evening_end: '晚间结束',
    profile_schedule_class_phase2_hint: '课表导入功能即将上线，敬请期待',
    profile_user_profile_reminder_enable: '开启定时提醒',
    profile_user_profile_reminder_permission: '通知权限',
    profile_user_profile_reminder_grant_permission: '去开启通知权限',
    profile_user_profile_reminder_today_count: '今日提醒',
    // ── Telemetry 看板 ──
    telemetry_hub_title: 'Telemetry 中心',
    telemetry_hub_desc: '埋点看板统一入口。选择业务模块后可查看关键指标、事件语义与运营决策提示。',
    telemetry_hub_open_dashboard: '打开看板',
    telemetry_hub_module_user_analytics_title: '用户分析',
    telemetry_hub_module_user_analytics_desc: '包含新增、DAU、付费转化、D7 留存与用户查询。',
    telemetry_hub_module_user_analytics_usecase: '用于监控增长、跟踪付费转化，并按用户维度做排查。',
    telemetry_hub_module_ai_annotation_title: 'AI 批注回复',
    telemetry_hub_module_ai_annotation_desc: '覆盖低叙事密度评分、横向联想采样、触发与凝结埋点。',
    telemetry_hub_module_ai_annotation_usecase: '用于校准触发概率，观察横向联想是否过弱或过频。',
    telemetry_hub_module_live_input_title: '实时输入 + 分类器',
    telemetry_hub_module_live_input_desc: '覆盖分类/纠错质量，并合并植物兜底与日记贴纸埋点。',
    telemetry_hub_module_live_input_usecase: '用于检查解析质量、纠错回路与多语言下的兜底稳定性。',
    telemetry_hub_module_todo_title: '待办拆解',
    telemetry_hub_module_todo_desc: '覆盖待办拆步质量、解析稳定性与用户重新拆解行为。',
    telemetry_hub_module_todo_usecase: '用于用产品可读指标判断 prompt/model 调优优先级。',
    telemetry_hub_module_profile_title: '个人设置',
    telemetry_hub_module_profile_desc: '覆盖根系方向设置的进入、修改、重置、保存结果与最终保存布局。',
    telemetry_hub_module_profile_usecase: '用于判断根系方向设置是否被发现、是否常用，以及是否值得继续投入 UI 优化。',
    telemetry_hub_module_feedback_title: '用户反馈',
    telemetry_hub_module_feedback_desc: '查看用户通过反馈表单提交的问题、建议与报告。',
    telemetry_hub_module_feedback_usecase: '用于了解用户痛点、Bug 频率与功能需求，指导产品迭代优先级。',
    telemetry_feedback_title: '用户反馈看板',
    telemetry_feedback_desc: '最近 200 条用户反馈，按提交时间倒序排列。',
    telemetry_feedback_reading_guide: '阅读建议：先看反馈总量趋势，再看问题类型占比。某类型突增通常意味着该链路出现集中性体验问题。',
    telemetry_feedback_total: '总反馈数',
    telemetry_feedback_total_hint: '统计窗口内提交的反馈总条数；连续上升通常表示问题暴露面扩大。',
    telemetry_feedback_type_hint: '该类型反馈条数；占比走高时可直接进入对应专项排查。',
    telemetry_feedback_list_title: '反馈列表',
    telemetry_feedback_loading: '加载中…',
    telemetry_feedback_empty: '暂无反馈',
    telemetry_common_days: '{{n}}天',
    telemetry_common_unknown: '未知',
    telemetry_common_na: '无',
    telemetry_common_yes: '是',
    telemetry_common_no: '否',
    // ── 实时输入看板 ──
    telemetry_live_title: '实时输入看板',
    telemetry_live_desc: '分类、纠错与植物素材兜底事件看板。日记贴纸与 AI 批注埋点已合并自',
    telemetry_live_load_failed: '实时输入看板加载失败。',
    telemetry_live_loading: '正在加载看板...',
    telemetry_live_admin_hint: '当前客户端元数据看起来不是管理员账号。如果线上返回 403，请把邮箱加入',
    telemetry_live_admin_hint_suffix: '或在 Supabase Auth metadata 中设置 admin 角色。',
    telemetry_live_error_hint: '该页面需要新建的 Supabase 表及服务端环境变量，例如',
    telemetry_live_summary_classifications: '分类次数',
    telemetry_live_summary_corrections: '纠错次数',
    telemetry_live_summary_correction_rate: '纠错率',
    telemetry_live_summary_unique_users: '去重用户数',
    telemetry_live_summary_plant_assets: '植物素材（L1 命中）',
    telemetry_live_summary_diary_stickers: '日记贴纸操作',
    telemetry_live_summary_bottle_linked: '瓶子自动关联次数',
    telemetry_live_summary_plant_generate: '植物生成（成功 / 失败）',
    telemetry_live_daily_series: '每日趋势',
    telemetry_live_modules_title: '功能子界面',
    telemetry_live_module_classification: '活动/心情分类',
    telemetry_live_module_tagging: '打标签与瓶子关联',
    telemetry_live_module_plant: '植物生成',
    telemetry_live_module_mixed: '其他混合事件',
    telemetry_live_breakdown_kind: '按分类结果（activity/mood）',
    telemetry_live_breakdown_kind_empty: '当前窗口暂无分类结果。',
    telemetry_live_breakdown_confidence: '按置信度',
    telemetry_live_breakdown_confidence_empty: '当前窗口暂无置信度数据。',
    telemetry_live_breakdown_internal_kind: '按内部类型',
    telemetry_live_breakdown_internal_kind_empty: '当前窗口暂无分类事件。',
    telemetry_live_breakdown_correction_paths: '纠错路径',
    telemetry_live_breakdown_correction_paths_empty: '当前窗口暂无纠错事件。',
    telemetry_live_breakdown_top_reasons: '高频原因',
    telemetry_live_breakdown_top_reasons_empty: '暂无原因码。',
    telemetry_live_breakdown_by_language: '按语言',
    telemetry_live_breakdown_by_language_empty: '暂无语言分布。',
    telemetry_live_breakdown_plant_fallback: '植物兜底层级',
    telemetry_live_breakdown_plant_fallback_empty: '暂无植物兜底埋点。',
    telemetry_live_breakdown_plant_generate_actions: '植物生成动作',
    telemetry_live_breakdown_plant_generate_actions_empty: '暂无植物生成埋点。',
    telemetry_live_breakdown_diary_actions: '日记贴纸动作',
    telemetry_live_breakdown_diary_actions_empty: '暂无日记贴纸埋点。',
    telemetry_live_breakdown_bottle_link_source: '瓶子关联来源',
    telemetry_live_breakdown_bottle_link_source_empty: '暂无瓶子关联来源数据。',
    telemetry_live_breakdown_bottle_link_target: '瓶子关联目标（按瓶子ID）',
    telemetry_live_breakdown_bottle_link_target_empty: '暂无瓶子关联目标数据。',
    telemetry_live_recent_events: '最近事件',
    telemetry_live_recent_empty: '暂无最近埋点事件。',
    telemetry_live_recent_len: '长度 {{n}}',
    telemetry_live_recent_annotation_event: '批注事件',
    telemetry_live_recent_score: '分数',
    telemetry_live_recent_diary_sticker_unknown: '未知贴纸事件',
    telemetry_live_recent_all: '全部',
    telemetry_live_recent_fallback: '兜底',
    telemetry_live_recent_report: '报告',
    telemetry_live_recent_date: '日期',
    telemetry_live_recent_order: '顺序',
    telemetry_live_recent_request: '请求',
    telemetry_live_recent_user: '用户',
    telemetry_live_table_day: '日期',
    telemetry_live_table_classifications: '分类',
    telemetry_live_table_corrections: '纠错',
    telemetry_live_table_plant_assets: '植物素材',
    telemetry_live_table_diary_stickers: '日记贴纸',
    telemetry_live_table_users: '用户',
    telemetry_live_hint_classifications: '自动分类触发总量。高代表使用活跃；低可能是入口触达或触发条件不足。',
    telemetry_live_hint_corrections: '用户手动纠正次数。高说明自动判断偏离用户心智。',
    telemetry_live_hint_correction_rate: '公式：纠错次数 / 分类次数。高时优先看纠错路径并修规则。',
    telemetry_live_hint_unique_users: '至少触发一次事件的去重人数。用于判断覆盖面而非频次。',
    telemetry_live_hint_plant_assets: '显示“植物素材总量 / L1 命中率”。L1 低说明兜底层级过深，需补素材或修映射。',
    telemetry_live_hint_diary_stickers: '日记贴纸操作次数。可用于评估日记互动功能的使用热度。',
    telemetry_live_hint_bottle_linked: '瓶子自动关联总次数（含 todo_link/keyword/ai）。用于评估自动奖励链路命中能力。',
    telemetry_live_hint_plant_generate: '展示“成功次数 / 失败次数”。失败偏高时优先排查植物生成链路与素材兜底。',
    telemetry_live_membership_title: '会员分类路径',
    telemetry_live_membership_desc: '从分类原因标签中聚合 Free/Plus 路径。用于判断 AI 是否稳定参与、以及瓶子匹配主要来自哪里。',
    telemetry_live_membership_user_plan: '按用户套餐',
    telemetry_live_membership_classification_path: '按分类路径',
    telemetry_live_membership_ai_called: '按 AI 是否调用',
    telemetry_live_membership_bottle_source: '按瓶子匹配来源',
    telemetry_live_membership_empty: '当前窗口暂无会员分类路径数据。',
    // ── AI 批注看板 ──
    telemetry_ai_title: 'AI 批注看板',
    telemetry_ai_desc: '用于追踪低叙事密度评分、横向联想采样、事件触发与后续凝结。',
    telemetry_ai_load_failed: 'AI 批注看板加载失败。',
    telemetry_ai_loading: '正在加载 AI 批注看板...',
    telemetry_ai_decision_hint: '调参提示：横向触发率长期高于 65% 可下调基础概率；低于 35% 可提高基础概率或增大概率增量。',
    telemetry_ai_summary_trigger_rate: '横向触发率',
    telemetry_ai_summary_samples: '横向采样数',
    telemetry_ai_summary_event_triggered: '触发事件数',
    telemetry_ai_summary_avg_score: '平均叙事分',
    telemetry_ai_summary_avg_probability: '平均最终概率',
    telemetry_ai_hint_trigger_rate: '公式：lateral_triggered / lateral_sampled。高于目标上限时可下调触发概率，低于下限时可提升。',
    telemetry_ai_hint_samples: '横向联想被采样的总次数。样本过低时先观察周期，不宜过早调参。',
    telemetry_ai_hint_event_triggered: '最终触发事件注入的次数。可与触发率联看判断是否过频或过稀。',
    telemetry_ai_hint_avg_score: '低叙事密度平均分。分数越低通常越应触发补叙事。',
    telemetry_ai_hint_avg_probability: '系统最终计算的平均触发概率。用于校准规则强度与真实触发结果是否一致。',
    telemetry_ai_bucket_title: '叙事分桶',
    telemetry_ai_bucket_desc: '含义：每个分桶聚合低密度分数。通常分数越低，经过概率调制后横向触发率应更高。',
    telemetry_ai_bucket_empty: '暂无叙事分桶数据。',
    telemetry_ai_table_bucket: '分桶',
    telemetry_ai_table_samples: '样本数',
    telemetry_ai_table_triggered: '触发数',
    telemetry_ai_table_trigger_rate: '触发率',
    telemetry_ai_breakdown_event_mix: '批注事件分布',
    telemetry_ai_breakdown_event_mix_desc: '查看批注链路中发生了什么，以及请求在哪些环节被拦截或转化。',
    telemetry_ai_breakdown_event_mix_empty: '暂无批注埋点事件。',
    telemetry_ai_breakdown_by_character: '按角色',
    telemetry_ai_breakdown_by_character_desc: '观察横向采样在不同角色间的分布，用于平衡与回归。',
    telemetry_ai_breakdown_by_character_empty: '暂无角色维度事件。',
    telemetry_ai_breakdown_association_types: '联想类型',
    telemetry_ai_breakdown_association_types_desc: '查看线上实际采样到的横向联想维度。',
    telemetry_ai_breakdown_association_types_empty: '暂无联想类型事件。',
    // ── 待办拆解看板 ──
    telemetry_todo_title: '待办拆解看板',
    telemetry_todo_desc: '面向产品的 AI 拆解质量看板。每个指标都包含业务解释与优化建议，便于快速决策。',
    telemetry_todo_load_failed: '待办拆解看板加载失败。',
    // ── 个人设置看板 ──
    telemetry_profile_title: '个人设置看板',
    telemetry_profile_desc: '用于观察 Profile 中根系方向设置的行为数据，包括进入、修改、重置、保存结果与最终保存布局。',
    telemetry_profile_loading: '正在加载个人设置看板...',
    telemetry_profile_load_failed: '个人设置看板加载失败。',
    telemetry_profile_reading_guide: '阅读提示：先看保存成功率，再对比打开次数与保存人数，以及每次保存前平均修改次数，判断这个设置到底是高频使用还是只被试探性点开。',
    telemetry_profile_summary_open: '打开次数',
    telemetry_profile_summary_open_hint: '该时间窗口内，用户进入根系方向设置面板的总次数。',
    telemetry_profile_summary_save_rate: '保存成功率',
    telemetry_profile_summary_save_rate_hint: '显式点击保存后，云端持久化成功的比例。',
    telemetry_profile_summary_users: '去重用户数',
    telemetry_profile_summary_users_hint: '至少触发过一次该设置链路的去重用户数。',
    telemetry_profile_summary_savers: '保存用户数',
    telemetry_profile_summary_savers_hint: '真正完成一次保存的去重用户数。',
    telemetry_profile_summary_avg_changes: '每次保存平均修改数',
    telemetry_profile_summary_avg_changes_hint: '用于观察用户在确认前会不会反复调整方向布局。',
    telemetry_profile_series_title: '每日趋势',
    telemetry_profile_series_desc: '按天查看打开、修改、重置、保存结果和去重用户变化。',
    telemetry_profile_series_empty: '暂无个人设置埋点。',
    telemetry_profile_table_day: '日期',
    telemetry_profile_table_open: '打开',
    telemetry_profile_table_change: '修改',
    telemetry_profile_table_reset: '重置',
    telemetry_profile_table_save: '保存成功',
    telemetry_profile_table_fail: '保存失败',
    telemetry_profile_table_users: '用户',
    telemetry_profile_breakdown_events: '事件构成',
    telemetry_profile_breakdown_events_desc: '看这个设置链路里，用户主要是在打开、修改、重置还是保存。',
    telemetry_profile_breakdown_events_empty: '暂无设置事件。',
    telemetry_profile_breakdown_slots: '高频修改位置',
    telemetry_profile_breakdown_slots_desc: '看用户最常改哪一个根系方向位置。',
    telemetry_profile_breakdown_slots_empty: '暂无位置修改事件。',
    telemetry_profile_breakdown_orders: '保存布局分布',
    telemetry_profile_breakdown_orders_desc: '看用户最终保存下来的完整方向布局偏好。',
    telemetry_profile_breakdown_orders_empty: '暂无保存布局。',
    telemetry_profile_recent_title: '最近事件',
    telemetry_profile_recent_desc: '用于质检和定性查看最近的根系方向交互。',
    telemetry_profile_recent_empty: '暂无最近根系方向事件。',
    telemetry_profile_recent_user: '用户',
    telemetry_profile_recent_slot: '位置',
    telemetry_profile_recent_from: '从',
    telemetry_profile_recent_to: '到',
    telemetry_profile_recent_order: '布局',
    telemetry_todo_loading: '正在加载待办拆解看板...',
    telemetry_todo_reading_guide: '阅读建议：先关注解析失败率与空步骤率（质量），再看重拆率（用户摩擦）以指导模型与 prompt 调优。',
    telemetry_todo_metric_label_what: '含义',
    telemetry_todo_metric_label_business: '业务影响',
    telemetry_todo_metric_label_action: '优化动作',
    telemetry_todo_metric_empty_rate_title: '空步骤率',
    telemetry_todo_metric_empty_rate_what: '在成功返回里，拆解结果为 0 个可用步骤的占比。',
    telemetry_todo_metric_empty_rate_business: '数值高表示用户点了功能却无法开工，信任会下降。',
    telemetry_todo_metric_empty_rate_action: '若上升，需提高提示词具体度，并结合语言/模型分布定位问题。',
    telemetry_todo_metric_parse_rate_title: '解析失败率',
    telemetry_todo_metric_parse_rate_what: '模型输出无法解析为预期 JSON 的占比。',
    telemetry_todo_metric_parse_rate_business: '数值高代表技术可靠性问题，会造成隐性挫败。',
    telemetry_todo_metric_parse_rate_action: '超基线时先降输出复杂度、降温度，再做模型对比。',
    telemetry_todo_metric_regenerate_rate_title: '重拆率',
    telemetry_todo_metric_regenerate_rate_what: '用户在拿到首版拆解后再次点击拆解的占比。',
    telemetry_todo_metric_regenerate_rate_business: '数值高说明首版结果可执行性不足。',
    telemetry_todo_metric_regenerate_rate_action: '优先检查重拆高的语言/模型，补充更贴近场景的示例。',
    telemetry_todo_metric_requested_title: '请求数',
    telemetry_todo_metric_requested_what: '拆解点击总量（首次 + 重拆）。',
    telemetry_todo_metric_requested_business: '反映功能需求与使用规模。',
    telemetry_todo_metric_requested_action: '结合成功/失败率联看；若量升质降，会放大用户挫败。',
    telemetry_todo_metric_succeeded_title: '成功数',
    telemetry_todo_metric_succeeded_what: '至少产出 1 个可用子步骤的请求量。',
    telemetry_todo_metric_succeeded_business: '核心有效产出，影响后续完成转化。',
    telemetry_todo_metric_succeeded_action: '每次调参后对比该值，理想是成功升、空/失败降。',
    telemetry_todo_metric_failed_title: '失败数',
    telemetry_todo_metric_failed_what: '拆解过程中的请求级失败（网络/服务/运行时）。',
    telemetry_todo_metric_failed_business: '表示用户被硬阻断，无法继续。',
    telemetry_todo_metric_failed_action: '若突增，先排查供应商状态和 API 错误，再做提示词优化。',
    telemetry_todo_metric_avg_steps_title: '平均步骤数/成功',
    telemetry_todo_metric_avg_steps_what: '成功拆解时平均产出的步骤数量。',
    telemetry_todo_metric_avg_steps_business: '过低可能太空泛，过高可能造成负担。',
    telemetry_todo_metric_avg_steps_action: '建议控制在可执行区间（通常 3-6），并结合重拆率平衡。',
    telemetry_todo_daily_title: '每日趋势',
    telemetry_todo_daily_desc: '观察质量随时间变化。健康趋势应是：请求稳定或上升，而解析失败/空步骤/失败持平或下降。',
    telemetry_todo_daily_empty: '暂无每日趋势数据。',
    telemetry_todo_breakdown_event_mix: '事件分布',
    telemetry_todo_breakdown_event_mix_desc: '按拆解事件阶段分布，便于做漏斗诊断。',
    telemetry_todo_breakdown_event_mix_empty: '暂无待办拆解事件。',
    telemetry_todo_breakdown_by_language: '按语言',
    telemetry_todo_breakdown_by_language_desc: '对比 zh/en/it 质量表现，指导语言级模型策略。',
    telemetry_todo_breakdown_by_language_empty: '暂无语言信号。',
    telemetry_todo_breakdown_by_model: '按模型',
    telemetry_todo_breakdown_by_model_desc: '观察哪些模型更容易出现空结果/失败/重拆。',
    telemetry_todo_breakdown_by_model_empty: '暂无模型使用信号。',
    telemetry_todo_recent_title: '最近待办拆解事件',
    telemetry_todo_recent_desc: '用于快速抽取坏例并复现同语言/模型配置做回归。',
    telemetry_todo_recent_empty: '暂无待办拆解埋点事件。',
    telemetry_todo_recent_regen: '重拆',
    telemetry_todo_recent_steps: '步骤',
    telemetry_todo_recent_todo: '待办',
    telemetry_todo_table_day: '日期',
    telemetry_todo_table_requested: '请求',
    telemetry_todo_table_succeeded: '成功',
    telemetry_todo_table_empty: '空结果',
    telemetry_todo_table_parse_failed: '解析失败',
    telemetry_todo_table_failed: '失败',
    telemetry_todo_table_regenerate: '重拆',
    // ── 用户数据看板 ──
    ua_title: '用户看板',
    ua_desc: '用于观察用户增长、付费转化和留存质量，并支持按用户定位问题。',
    ua_updated: '更新于',
    ua_loading: '加载中...',
    ua_back: '← 返回',
    ua_days_7: '7 天',
    ua_days_14: '14 天',
    ua_days_30: '30 天',
    ua_days_60: '60 天',
    ua_total_users: '总用户',
    ua_hint_total_users: '累计注册用户规模。用于判断整体盘子增长速度。',
    ua_total_premium: '付费用户',
    ua_hint_total_premium: '累计付费用户及转化率。高低直接反映会员价值与定价匹配度。',
    ua_conversion: '转化率',
    ua_active_today: '今日活跃',
    ua_hint_active_today: '今日至少活跃一次的用户数。可用来判断产品日常粘性。',
    ua_new_today: '今日新增',
    ua_hint_new_today: '今日新注册用户。若新增高但活跃低，需优化首日激活链路。',
    ua_premium_sub: '付费 {{n}}',
    ua_daily_series: '每日数据',
    ua_day: '日期',
    ua_new_users: '新用户',
    ua_dau: '日活',
    ua_new_premium: '新付费',
    ua_active_premium: '活跃付费',
    ua_retention_title: 'D7 留存（周粒度分群）',
    ua_retention_desc: '注册于第 W 周、并在第 W+1 周发过消息的用户比例。',
    ua_retention_empty: '数据不足（需要至少 2 周的用户数据）。',
    ua_cohort_week: '注册周',
    ua_retained_d7: 'D7 留存数',
    ua_d7_rate: 'D7 留存率',
    ua_lookup_title: '用户查询',
    ua_lookup_placeholder: '邮箱或用户 ID',
    ua_lookup_search: '查询',
    ua_lookup_not_found: '未找到用户「{{query}}」。',
    ua_field_id: 'ID',
    ua_field_email: '邮箱',
    ua_field_registered: '注册时间',
    ua_field_premium: '付费状态',
    ua_field_premium_yes: '已付费（{{plan}}）',
    ua_field_premium_no: '未付费',
    ua_field_messages: '消息总数',
    ua_field_focus: '专注次数',
    ua_field_streak: '连续登录天数',
    ua_field_last_active: '最后活跃',
    ua_field_never: '从未活跃',
    ua_field_plan_unknown: '套餐未知',

    // Help & Support
    // Delete account
    delete_account_label: '删除账号',
    delete_account_title: '删除账号',
    delete_account_subscription_title: '请先取消订阅',
    delete_account_subscription_body: '如果你有有效的 Seeday Plus 订阅，请先前往 iPhone 设置 → 你的姓名 → 订阅 手动取消，否则仍会继续扣费。',
    delete_account_grace_note: '提交后将立即开始永久删除。若任何服务端步骤失败，删除会中断并提示重试；完成后账号无法恢复。',
    delete_account_warning: '以下内容将被永久删除：',
    delete_account_item1: '账号登录信息',
    delete_account_item2: '所有聊天记录与日记内容',
    delete_account_item3: '所有待办、目标与习惯',
    delete_account_item4: '所有报告、统计、反馈与遥测数据',
    delete_account_item5: 'Storage 中的图片与所有本地缓存数据',
    delete_account_confirm_label: '我已了解，系统将立即开始永久删除；完成后账号无法恢复',
    delete_account_button: '立即删除账号',
    delete_account_cancel: '取消',
    delete_account_loading: '处理中…',
    delete_account_error: '操作失败，请稍后重试',
    delete_account_success: '账号已删除。',
    delete_account_restored: '欢迎回来！你的账号已恢复。',

    // Feedback
    feedback_sheet_title: '发送反馈',
    feedback_intro: '请尽可能详细地描述你的经历，以便我们更好地了解问题所在。',
    feedback_email_label: '邮箱地址',
    feedback_email_placeholder: '你的邮箱',
    feedback_subject_label: '主题',
    feedback_subject_placeholder: '用一句话概括问题',
    feedback_type_label: '问题类型',
    feedback_type_placeholder: '请选择一项',
    feedback_type_bug: '错误报告',
    feedback_type_account: '账号问题',
    feedback_type_subscription: '订阅与付款',
    feedback_type_feature: '产品反馈或功能建议',
    feedback_type_data: '数据与隐私',
    feedback_type_other: '其他',
    feedback_desc_label: '描述',
    feedback_desc_placeholder: '请详细描述你遇到的问题或建议…',
    feedback_submit: '提交',
    feedback_required: '请填写所有必填项',
    feedback_open_mail: '即将打开邮件客户端，请确认后发送。',
    feedback_success_title: '反馈已发送',
    feedback_success_body: '谢谢你告诉我们，我们会认真查看。',
    feedback_success_close: '完成',

    auth_tos_prefix: '注册即代表您同意我们的',
    auth_tos_privacy_link: '隐私政策',
    auth_tos_required: '请先同意隐私政策后继续',

    help_sheet_title: '帮助与支持',
    help_intro: '有任何问题，我们随时在这里。',
    help_sec_start: '开始使用',
    help_q1: '如何开始记录？',
    help_a1: '在聊天框里自然输入即可，比如“吃了早饭，心情不错”，Seeday 会自动识别活动和情绪。',
    help_q2: 'AI 伙伴是什么？',
    help_a2: 'AI 伙伴会回应你的记录内容。Van 是免费伙伴；Agnes、Zep 和 Momo 需要 Seeday Plus 解锁。',
    help_sec_chat: '聊天与日记',
    help_q3: '魔法笔是什么？',
    help_a3: '魔法笔是智能输入工具，可将"8 点跑步 30 分钟"等结构化内容自动解析为活动记录。',
    help_q4: '可以编辑或删除记录吗？',
    help_a4: '可以。点击消息卡片可看到删除选项；点击时间轴可编辑该活动的时间和内容。',
    help_sec_growth: '目标与习惯',
    help_q5: '瓶子是什么？',
    help_a5: '瓶子是习惯与目标的养成工具。事件卡片会自动关联相关内容长成星星，后续将开放满瓶浇灌周报与月报植物能力，敬请期待。',
    help_q6: '支持重复任务吗？',
    help_a6: '支持。可以为任意待办设置每日、每周或自定义重复周期。',
    help_sec_report: '每日报告',
    help_q7: '每日植物和今日日记什么时候可见？',
    help_a7: '每日植物和今日日记（AI 观察日记）相关内容在 20:00 后可显示或可生成，请在晚上 8 点后查看。',
    help_sec_membership: '会员',
    help_q8: 'Seeday Plus 包含哪些内容？',
    help_a8: 'Plus 解锁全部 4 位 AI 伙伴、高频智能批注（最多 9999 条/天）、AI 长期记忆等功能。',
    help_q9: '如何管理或取消订阅？',
    help_a9: '可在 App Store（头像 → 订阅）或 iPhone 设置（你的姓名 → 订阅）中找到 Seeday，并选择取消订阅。',
    help_sec_account: '账号',
    help_q10: '如何删除账号？',
    help_a10: '在个人主页点击"删除账号"，账号及所有数据将被永久删除。',
    help_q11: '如何添加和编辑待办？',
    help_a11: '在近日要事中输入文本后回车即可添加待办。点击待办卡片可编辑紧急程度、截止时间、关联瓶子，并可设置每天或每周重复。',
    help_q12: '待办上的按钮都有什么作用？',
    help_a12: '点击置顶按钮，可以把这一条待办置顶；点击中间三角开始按钮可开始任务；点击闹钟按钮可开始专注；会员用户还可以使用“分步完成”将任务拆解子步骤，并点击闹钟开启按步骤连续专注模式。',
    help_q13: '瓶子里还可以做什么？',
    help_a13: '点击瓶子后可查看打卡数据，也可直接生成待办，或删除该瓶子。',
    help_contact_label: '还有其他问题？',
    help_contact_desc: '想联系我们获得支持？请发邮件至',
    help_contact_reply: '',

    // Privacy Policy
    privacy_sheet_title: '隐私政策',
    ai_consent_settings_label: 'AI 数据与同意',
    ai_consent_settings_title: 'AI 数据与同意',
    ai_consent_version: '同意版本 {{version}}',
    ai_consent_title: '在使用 AI 功能前，请先选择',
    ai_consent_intro: '只有在你明确同意后，Seeday 才会把提供所选 AI 功能所必需的数据发送给第三方 AI 服务。不同意也可以继续使用不需要 AI 的功能。',
    ai_consent_data_title: '可能发送的数据',
    ai_consent_data_body: '你输入的日记、聊天或待办文本，以及所选功能需要的心情、活动、历史摘要、个性化偏好和天气等上下文。不会发送账号密码或支付信息。',
    ai_consent_providers_title: '接收方与目的',
    ai_consent_providers_body: 'DeepSeek、OpenAI 和 Google Gemini 会按语言和所选功能处理必要数据，用于分类、拆解待办、生成批注、日记、洞察、画像或植物日记文案。',
    ai_consent_control_title: '留存与控制',
    ai_consent_control_body: '我们已关闭已核实账号中的训练共享，并尽量关闭应用数据存储；服务商仍可能依其条款保留有限的安全或滥用监测日志。你可以随时在设置中撤回同意，撤回后不会再发送新的 AI 请求。',
    ai_consent_checkbox: '我明确同意将上述必要数据发送给 DeepSeek、OpenAI 和 Google Gemini，以提供我选择使用的 AI 功能。',
    ai_consent_read_privacy: '查看完整隐私政策',
    ai_consent_agree: '同意并启用 AI',
    ai_consent_without_ai: '不同意，继续使用非 AI 功能',
    ai_consent_withdraw: '撤回同意并停用 AI',
    ai_consent_saving: '保存中…',
    ai_consent_save_error: '无法保存你的选择。为保护你的数据，AI 功能仍保持关闭，请稍后重试。',
    ai_consent_status_label: '当前状态',
    ai_consent_status_granted: '已同意，可使用 AI 功能',
    ai_consent_status_off: '未同意，AI 数据发送已关闭',
    privacy_updated: '最后更新：2026 年 7 月 31 日',
    privacy_intro: 'Seeday（以下简称"我们"）致力于保护您的隐私。本政策说明我们收集哪些数据、如何使用以及您拥有的权利。',
    privacy_s1_title: '一、我们收集的信息',
    privacy_s1_body: '账号信息：注册邮箱、显示名称及头像（如已设置）。\n日记内容：您输入的消息、心情、活动、待办事项和备注。\n使用数据：功能交互频率及应用性能指标。\n设备信息：设备类型、操作系统版本及时区。',
    privacy_s2_title: '二、信息使用方式',
    privacy_s2_body: '我们将您的信息用于以下目的：提供和改进应用体验；生成 AI 伴侣回应与智能批注；创建每日报告；通过 Apple 应用内购买处理订阅；发送可选的推送通知提醒。\n\n我们不会将您的个人数据出售给第三方。',
    privacy_s3_title: '三、AI 数据处理',
    privacy_s3_body: '在首次向第三方 AI 服务发送数据前，我们会单独说明接收方、数据类型与用途，并取得您的明确同意。不同意不会影响不需要 AI 的基础功能；您也可随时在“设置 → AI 数据与同意”中撤回，撤回后新的第三方 AI 请求会被阻止。\n\n当前服务商为 DeepSeek（中文批注、输入分类、中文待办拆解与魔法笔解析）、OpenAI（英文/意大利文批注、日记与短洞察生成、用户画像提取及植物日记文案）和 Google Gemini（英文/意大利文待办拆解）。仅发送所选功能所需的内容与上下文。',
    privacy_s4_title: '四、第三方服务',
    privacy_s4_body: 'Supabase Free：身份认证、数据库与文件存储；当前套餐没有计划备份、PITR 或 Log Drain，平台日志保留以 Supabase 当前套餐规则为准。\nApple IAP：iOS 端订阅计费与订阅状态验证，受 Apple 隐私政策约束。\nOpen-Meteo：在您设置地区后，使用相应经纬度获取天气与空气质量信息；不向其发送日记正文。\nAI 服务商：DeepSeek、OpenAI、Google Gemini。OpenAI 请求已设置 store=false，账号中的模型反馈、评估/微调及输入输出共享均已关闭；Gemini 付费项目的 GenerateContent 日志存储已关闭，未使用已开启 55 天默认留存的 Interactions API。服务商仍可能为安全、滥用监测或依法合规保留有限记录，具体以适用条款及实际账号设置为准。',
    privacy_s5_title: '五、数据留存',
    privacy_s5_body: '账号处于活跃状态期间，我们会保留提供服务所需的数据。您提交账号删除后，系统会立即尝试删除用户域数据库记录、Storage 文件、反馈、遥测和登录账号；若任何步骤失败，删除会中断并显示失败，账号不会被误报为已删除，您可以重试或联系我们。第三方服务商的安全/滥用监测日志及基础设施备份可能按其各自期限到期，无法承诺在账号删除瞬间同步清除。',
    privacy_s6_title: '六、您的权利',
    privacy_s6_body: '您可随时访问、导出或删除数据，或在“设置 → AI 数据与同意”中撤回第三方 AI 数据发送同意。撤回不影响撤回前处理的合法性。您也可以使用应用内账号删除功能或发送邮件至我们的支持邮箱。\n\n如果您位于欧洲经济区，您还拥有 GDPR 授予的额外权利，包括数据可移植权和向监管机构投诉的权利。',
    privacy_s7_title: '七、儿童隐私',
    privacy_s7_body: 'Seeday 不面向 13 岁以下未成年人。我们不会主动收集儿童的个人数据。',
    privacy_s8_title: '八、政策变更',
    privacy_s8_body: '我们可能会定期更新本政策，并在重大变更时通过应用内方式告知您。若变更需要新的同意，我们会在继续发送相关数据前再次请求您的明确选择。',
    privacy_s9_title: '联系我们',
    privacy_s9_body: '如有隐私相关问题，请联系：',

    // ── 日历 ──
    cal_month_jan: '一月',
    cal_month_feb: '二月',
    cal_month_mar: '三月',
    cal_month_apr: '四月',
    cal_month_may: '五月',
    cal_month_jun: '六月',
    cal_month_jul: '七月',
    cal_month_aug: '八月',
    cal_month_sep: '九月',
    cal_month_oct: '十月',
    cal_month_nov: '十一月',
    cal_month_dec: '十二月',
    cal_day_sun: '日',
    cal_day_mon: '一',
    cal_day_tue: '二',
    cal_day_wed: '三',
    cal_day_thu: '四',
    cal_day_fri: '五',
    cal_day_sat: '六',

    // About
    about_sheet_title: '关于应用',
    about_tagline: '你的 AI 生活日记伴侣',
    about_desc: '用对话记录每一天，让 AI 发现你故事里的意义，帮助你更好地生活。',
    about_version_label: '版本',
    about_developer_label: '开发者',
    about_developer_name: 'Seeday Team',
    about_support_label: '联系支持',
    about_privacy_link: '隐私政策',
    about_copyright: '© 2025 Seeday. 保留所有权利。',

    // 协议文案拆分（登录/注册底部）
    auth_agreement_prefix: '继续前可查看',
    auth_agreement_terms: '《服务协议》',
    auth_agreement_and: '与',
    auth_agreement_privacy: '《隐私政策》',

    // 服务协议面板
    terms_sheet_title: '服务协议',
    terms_updated: '最后更新：2026 年 5 月 2 日',
    terms_intro: '本服务协议自您首次使用 Seeday 之日起生效。继续使用即表示您接受以下全部条款。',
    terms_s1_title: '1. 协议主体',
    terms_s1_body: '本协议由您（终端用户）与 Seeday 开发团队（以下简称"我们"）订立。Apple Inc. 及其关联公司不是本协议的当事方，对本应用及其内容不承担任何责任。',
    terms_s2_title: '2. 许可授权',
    terms_s2_body: '我们授予您在您所有或控制的 Apple 品牌设备上，以非独占、不可转让的方式使用本应用的个人许可，适用范围以 Apple 媒体服务条款与条件中的使用规则为准。',
    terms_s3_title: '3. 订阅与付款',
    terms_s3_body: '本应用提供可选订阅服务（Seeday Pro），全部通过 Apple App Store 内购（IAP）处理。订阅定价与期限以 App Store 页面展示为准。订阅到期后自动续期，如需取消请在 Apple ID 订阅设置中操作。退款申请须通过 Apple 提交，我们不直接处理退款。',
    terms_s4_title: '4. 禁止行为',
    terms_s4_body: '您不得：对本应用进行反向工程、反编译或以其他方式提取源代码；将本应用用于任何违法目的；上传含有侵权、骚扰或恶意内容的数据；以任何方式干扰本应用的正常运行。',
    terms_s5_title: '5. 维护与支持',
    terms_s5_body: '我们作为开发者，全权负责本应用的维护与支持服务。Apple 对本应用的维护和支持不承担任何义务。如需帮助，请发送邮件至 hello@seedayapp.com。',
    terms_s6_title: '6. 保修声明',
    terms_s6_body: '在适用法律允许的最大范围内，本应用按"现状"提供，不附任何明示或默示保证。如本应用不符合任何适用保修，您可通知 Apple，Apple 将退还购买价款；除此之外，Apple 对本应用不承担任何其他保修义务，相关索赔、损失及费用均由我们承担。',
    terms_s7_title: '7. 产品责任与索赔',
    terms_s7_body: '与本应用相关的任何产品责任索赔、法规合规要求及消费者保护投诉，均由我们（而非 Apple）负责处理。Apple 对此不承担任何责任。',
    terms_s8_title: '8. 知识产权',
    terms_s8_body: '如第三方主张本应用或您对本应用的使用侵犯其知识产权，由我们（而非 Apple）全权负责调查、抗辩、和解与处置此类索赔。Apple 对此不承担任何责任。',
    terms_s9_title: '9. 合规声明',
    terms_s9_body: '您使用本应用即声明并保证：(i) 您所在地区不受美国政府禁运制裁，且不属于被美国政府认定为"支持恐怖主义"的地区；(ii) 您未被列入美国政府的任何禁止或限制方名单。',
    terms_s10_title: '10. 第三方服务条款',
    terms_s10_body: '使用本应用期间，您须同时遵守适用的第三方服务条款，包括 Apple 媒体服务条款与条件及您的无线数据服务协议（如适用）。',
    terms_s11_title: '11. Apple 作为第三方受益人',
    terms_s11_body: '您与我们均承认并同意，Apple Inc. 及其子公司是本协议的第三方受益人。一旦您接受本协议条款，Apple 将有权（并被视为已接受该权利）作为第三方受益人对您执行本协议。',
    terms_s12_title: '12. 开发者联系方式',
    terms_s12_body: '开发团队：Seeday\n联系邮箱：hello@seedayapp.com\n\n如对本协议有任何疑问、投诉或索赔，请通过上述邮箱与我们联系。',
};
